import { Helmet } from "react-helmet-async";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useI18n } from "@/context/I18nContext";

// AEO FAQ: renders a clean accordion AND emits FAQPage structured data so answer
// engines + search can extract the Q/A pairs. `faqs` = [{ q, a }].
export const AeoFaq = ({ faqs = [], title = "Frequently asked questions" }) => {
  const { tx } = useI18n();
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  return (
    <div data-testid="aeo-faq">
      {faqs.length > 0 && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        </Helmet>
      )}
      <h2 className="font-display text-2xl sm:text-3xl">{tx(title)}</h2>
      <Accordion type="single" collapsible className="mt-5">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} data-testid={`aeo-faq-item-${i}`}>
            <AccordionTrigger className="text-left text-[15px] font-medium">{tx(f.q)}</AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-muted-foreground">{tx(f.a)}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};
